import { render, staticRenderFns } from "./CategoryCommon.vue?vue&type=template&id=11bab2d2&scoped=true&"
import script from "./CategoryCommon.vue?vue&type=script&lang=js&"
export * from "./CategoryCommon.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCommon.vue?vue&type=style&index=0&id=11bab2d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bab2d2",
  null
  
)

export default component.exports